import { RslSetttingDto } from "./RslDataType";
import BridgeSettings from "./setting/BridgeSettings";
import Bridge from "../../core/assets/oot/classic/bridge.jpg"
import Stone from "../../core/assets/oot/gshd/kokiri-stone_32x32.png"
import Medallion from "../../core/assets/oot/gshd/yellow-medallion_32x32.png"
import Skull from "../../core/assets/oot/gshd/collected-skulltulas_32x32.png"
import Hearts from "../../core/assets/oot/classic_improve/heart container.png"
import Pot from "../../core/assets/oot/classic/pot.png"
import Crate from "../../core/assets/oot/classic/crate.png"
import Freestanding from "../../core/assets/oot/classic/Green_Rupee_Artwork.png"
import Deadge from "../../core/assets/oot/classic/deadge.png"

export const PotCrateFreestandingSetting: RslSetttingDto = {
    name: "Pot / Crate / Freestanding", states: [
        {name: "Off", chance: 0, img: Deadge},
        {name: "Pot", chance: 33, img: Pot},
        {name: "Crate", chance: 33, img: Crate},
        {name: "Freestanding", chance: 33, img: Freestanding},
        ],
        defaultState: "Off",
        type: "classic"
}

export const SoulsanitySetting: RslSetttingDto = {
    name: "Soulsanity", states: [
        {name: "Off", chance: 0, img: Deadge},
        {name: "Boss", chance: 33, img: Pot},
        {name: "Regional", chance: 33, img: Crate},
        {name: "All", chance: 33, img: Freestanding},
        ],
        defaultState: "Off",
        type: "classic"
}

export const MixPoolSetting: RslSetttingDto = {
    name: "Mixpool", states: [
        {name: "Interior", chance: 30},
        {name: "Grotto", chance: 30},
        {name: "Dungeon", chance: 30},
        {name: "Overworld", chance: 30},
        ],
        type: "multiselect",
}

export const OcarinaNoteSetting: RslSetttingDto = {
    name: "Ocarina Notes", states: [
        {name: "On", chance: 10},
        {name: "Off", chance: 90},
        ],
        defaultState: "Off",
        type: "classic"
}
export const EnnemySoulSetting: RslSetttingDto =     {
    name: "Boulder Shuffle", states: [
    {name: "Off", chance: 85},
    {name: "all", chance: 5},
    {name: "Bosses", chance: 5},
    {name: "Regional", chance: 5},
    ],
    defaultState: "Off",
    type: "classic"
}

export const BoulderSetting: RslSetttingDto =     {
    name: "Boulder Shuffle", states: [
    {name: "On", chance: 10},
    {name: "Off", chance: 90},
    ],
    defaultState: "Off",
    type: "classic"
}
export const SilverRuppeSetting: RslSetttingDto =     {
    name: "Silver Rupees", states: [
        {name: "Remove", chance: 5},
        {name: "Vanilla", chance: 80},
        {name: "Dungeon", chance: 5},
        {name: "Regional", chance: 5},
        {name: "Anywhere", chance: 5},
    ],
    defaultState: "Vanilla",
    type: "classic"
}

export const KeyringBkSetting: RslSetttingDto = {
    name: "Keyring Give BK", states: [
        {name: "Yes", chance: 25},
        {name: "No", chance: 75},
    ],
    defaultState: "No",
    type: "classic"
}


export const BombchusDropSetting: RslSetttingDto =     {
    name: "Bombchus Drop", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const AdultTradeSetting: RslSetttingDto =  {
    name: "Adult Trade", states: [
        {name: "Yes", chance: 25},
        {name: "No", chance: 75},
    ],
    defaultState: "No",
    type: "classic"
}

export const DekuSetting: RslSetttingDto = {
    name: "Open Deku", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const KakGateSetting: RslSetttingDto =     {
    name: "Open Gate", states: [
        {name: "Yes", chance: 50},
        {name: "Zelda Letter", chance: 50},
    ],
    defaultState: "Zelda Letter",
    type: "classic"
}

export const DotSetting: RslSetttingDto =     {
    name: "Open DoT", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
     defaultState: "No",
    type: "classic"
}

export const FountainSetting: RslSetttingDto =     {
    name: "Open Fountain", states: [
        {name: "Yes", chance: 25},
        {name: "No", chance: 75},
    ],
     defaultState: "No",
    type: "classic"
}
export const FortressSetting: RslSetttingDto =    {
    name: "Fortress", states: [
        {name: "Open (0)", chance: 33},
        {name: "Fast (1)", chance: 33},
        {name: "Normal (4)", chance: 33},
    ],
    defaultState: "Fast",
    type: "classic"
}

export const BridgeSetting: RslSetttingDto =  {
    name: "Bridge", states: [
        {name: "Open", chance: 20},
        {name: "Vanilla", chance: 20},
        {name: "Stones", chance: 20, img: Stone},
        {name: "Medallions", chance: 20, img: Medallion},
        {name: "Dungeons", chance: 20},
        {name: "Skulls", chance: 0, img: Skull},
        {name: "Hearts", chance: 0, img: Hearts},
    ],
    type: "classic",
    component: BridgeSettings,
    img: Bridge

}

export const BridgeMedallionSetting: RslSetttingDto =  {
    name: "Bridge Medallions", states: [
        {name: "1", chance: 5},
        {name: "2", chance: 5},
        {name: "3", chance: 10},
        {name: "4", chance: 10},
        {name: "5", chance: 20},
        {name: "6", chance: 50},
    ],
    type: "classic"
}

export const BridgeStoneSetting: RslSetttingDto =   {
    name: "Bridge Stones", states: [
        {name: "1", chance: 5},
        {name: "2", chance: 45},
        {name: "3", chance: 50}
    ],
    type: "classic"
}

export const BridgeDungeonSetting: RslSetttingDto =     {
    name: "Bridge Dungeon", states: [
        {name: "1", chance: 2.5},
        {name: "2", chance: 2.5},
        {name: "3", chance: 5},
        {name: "4", chance: 5},
        {name: "5", chance: 5},
        {name: "6", chance: 10},
        {name: "7", chance: 10},
        {name: "8", chance: 10},
        {name: "9", chance: 50},
    ],
    type: "classic"
}
export const TriforceHuntSetting: RslSetttingDto =     {
    name: "Triforce Hunt", states: [
        {name: "No", chance: 90},
        {name: "Yes", chance: 10},
    ],
    defaultState: "No",
    type: "classic"

}


export const TrialSetting: RslSetttingDto = {
    name: "Trials", states: [
        {name: "0", chance: 1/7*100},
        {name: "1", chance: 1/7*100},
        {name: "2", chance: 1/7*100},
        {name: "3", chance: 1/7*100},
        {name: "4", chance: 1/7*100},
        {name: "5", chance: 1/7*100},
        {name: "6", chance: 1/7*100},
    ],
    type: "classic"
}
export const InteriorShuffleSetting: RslSetttingDto =     {
    name: "Interior Shuffle", states: [
        {name: "Off", chance: 50},
        {name: "Simple", chance: 25},
        {name: "All", chance: 25},

    ],
     defaultState: "Off",
    type: "classic"
}

export const OverworldShuffleSetting: RslSetttingDto =     {
    name: "Overworld Shuffle", states: [
        {name: "Yes", chance: 30},
        {name: "No", chance: 70},
    ],
    defaultState: "Off",
    type: "classic"
}

export const GrottoShuffleSetting: RslSetttingDto = {
    name: "Grotto Shuffle", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const DungeonShuffleSetting: RslSetttingDto =   {
    name: "Dungeon Shuffle", states: [
        {name: "Off", chance: 45},
        {name: "Simple", chance: 45},
        {name: "All", chance: 10},
    ],
    defaultState: "Off",
    type: "classic"
}

export const BossShuffleSetting: RslSetttingDto =     {
    name: "Boss Shuffle", states: [
        {name: "Yes", chance: 20},
        {name: "No", chance: 80},
    ],
    defaultState: "Off",
    type: "classic"
}

export const OwlDropSetting: RslSetttingDto = {
    name: "Owl Drop", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "Off",
    type: "classic"
}

export const WarpSongSetting: RslSetttingDto = {
    name: "Warp Song", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "Off",
    type: "classic"
}

export const ShopsanitySetting: RslSetttingDto =  {
    name: "Shopsanity", states: [
        {name: "Off", chance: 2/9*100},
        {name: "0", chance: 1/9*100},
        {name: "1", chance: 1/9*100},
        {name: "2", chance: 1/9*100},
        {name: "3", chance: 1/9*100},
        {name: "4", chance: 1/9*100},
        {name: "Random", chance: 2/9*100},
    ],
    defaultState: "Off",
    type: "classic"
}

export const TokensanitySetting: RslSetttingDto =  {
    name: "Tokensanity", states: [
        {name: "Off", chance: 30},
        {name: "Dungeon", chance: 25},
        {name: "Overworld", chance: 25},
        {name: "All", chance: 20}
    ],
    defaultState: "Off",
    type: "classic"
}

export const ScrubsanitySetting: RslSetttingDto =   {
    name: "Scrubsanity", states: [
        {name: "Off", chance: 33},
        {name: "Affordable", chance: 33},
        {name: "Vanilla", chance: 20},
        {name: "Random", chance: 13}
    ],
    defaultState: "Off",
    type: "classic"
}

export const CowsanitySetting: RslSetttingDto = {
    name: "Cowsanity", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const SongSanitySettin: RslSetttingDto =     {
    name: "Songsanity", states: [
        {name: "Song", chance: 40},
        {name: "Dungeon", chance: 20},
        {name: "Any", chance: 40},
    ],
    defaultState: "Song",
    type: "classic"
}

export const KsSetting: RslSetttingDto =    {
    name: "KS Shuffle", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const OcarinaSetting: RslSetttingDto =  {
    name: "Ocarina Shuffle", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const GerudoCardSetting: RslSetttingDto = {
    name: "Gerudo Card Shuffle", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const BeanShuffle: RslSetttingDto = {
    name: "Beans Shuffle", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const ExpensiveMerchantsSetting: RslSetttingDto =   {
    name: "Exp. Merchants", states: [
        {name: "Yes", chance: 40},
        {name: "No", chance: 60},
    ],
    defaultState: "No",
    type: "classic"
}

export const FrogSongShuffleSetting: RslSetttingDto =  {
    name: "Frogs Shuffle", states: [
        {name: "Yes", chance: 15},
        {name: "No", chance: 85},
    ],
    defaultState: "No",
    type: "classic"
}

export const MapCompassShuffleSetting: RslSetttingDto =  {
    name: "Map Compass Shuffle", states: [
        {name: "Remove", chance: 12.5},
        {name: "Start", chance: 12.5},
        {name: "Vanilla", chance: 12.5},
        {name: "Dungeon", chance: 12.5},
        {name: "Overworld", chance: 12.5},
        {name: "Any Dungeon", chance: 12.5},
        {name: "Everywhere", chance: 12.5},
        {name: "Regional", chance: 12.5},
    ],
    defaultState: "Remove",
    type: "classic"
}

export const KeysanitySetting: RslSetttingDto = {
    name: "Keysanity", states: [
        {name: "Keysy", chance: 18},
        {name: "Vanilla", chance: 18},
        {name: "Dungeon", chance: 18},
        {name: "Overworld", chance: 9},
        {name: "Any Dungeon", chance: 9},
        {name: "Everywhere", chance: 18},
        {name: "Regional", chance: 9},
    ],
    defaultState: "Dungeon",
    type: "classic"
}
export const KeyringSetting: RslSetttingDto = {
    name: "Keyring", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const BkSanitySetting: RslSetttingDto =  {
    name: "BK sanity", states: [
        {name: "Keysy", chance: 20},
        {name: "Vanilla", chance: 20},
        {name: "Dungeon", chance: 20},
        {name: "Everywhere", chance: 20},
        {name: "Regional", chance: 20},
    ],
    defaultState: "Dungeon",
    type: "classic"
}
export const GbkSetting: RslSetttingDto =  {
    name: "GBK", states: [
        {name: "Keysy", chance: 16},
        {name: "Vanilla", chance: 16},
        {name: "Ganon Castle", chance: 16},
        {name: "Overworld", chance: 5},
        {name: "Any Dungeon", chance: 5},
        {name: "Regional", chance: 5},
        {name: "Anywhere", chance: 5},
        {name: "LACS", chance: 11},
        {name: "Medallions", chance: 5},
        {name: "Stones", chance: 5},
        {name: "Dungeons", chance: 5},
        {name: "Skull", chance: 5},
        {name: "Hearts", chance: 5},
    ],
    type: "classic"
}
export const GbkMedallionSettings: RslSetttingDto = {
    name: "GBK Medallions", states: [
        {name: "1", chance: 5},
        {name: "2", chance: 5},
        {name: "3", chance: 10},
        {name: "4", chance: 10},
        {name: "5", chance: 20},
        {name: "6", chance: 50},
    ],
    type: "classic"
}

export const GbkStoneSetting: RslSetttingDto =  {
    name: "GBK Stones", states: [
        {name: "1", chance: 5},
        {name: "2", chance: 45},
        {name: "3", chance: 50}
    ],
    type: "classic"
}
export const GbkDungeonSettings: RslSetttingDto =  {
    name: "GBK Dungeon", states: [
        {name: "1", chance: 2.5},
        {name: "2", chance: 2.5},
        {name: "3", chance: 5},
        {name: "4", chance: 5},
        {name: "5", chance: 5},
        {name: "6", chance: 10},
        {name: "7", chance: 10},
        {name: "8", chance: 10},
        {name: "9", chance: 50},
    ],
    type: "classic"
}

export const MapCompassInfoSetting: RslSetttingDto = {
    name: "Map / Compass Info", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const BeatableOnlySettings: RslSetttingDto =  {
    name: "Beatable Only", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}
export const EscapeSequence: RslSetttingDto = {
    name: "Escape Sequence", states: [
        {name: "Yes", chance: 60},
        {name: "No", chance: 40},
    ],
    defaultState: "No",
    type: "classic"
}

export const FreeEponaSetting: RslSetttingDto =  {
    name: "Epona Race", states: [
        {name: "No", chance: 40},
        {name: "Yes", chance: 60},
    ],
    defaultState: "No",
    type: "classic"
}

export const FreeScarecrowSetting: RslSetttingDto = {
    name: "Free Scarecrow", states: [
        {name: "No", chance: 50},
        {name: "Yes", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const CompletedMaskQuestSetting: RslSetttingDto = {
    name: "Complete Mask", states: [
        {name: "No", chance: 50},
        {name: "Yes", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}
export const PrePlantedBean: RslSetttingDto =  {
    name: "Planted Beans", states: [
        {name: "No", chance: 58},
        {name: "Yes", chance: 42},
    ],
    defaultState: "No",
    type: "classic"
}

export const BigPoesSetting: RslSetttingDto = {
    name: "Big Poes", states: [
        {name: "1", chance: 10},
        {name: "2", chance: 10},
        {name: "3", chance: 10},
        {name: "4", chance: 10},
        {name: "5", chance: 10},
        {name: "6", chance: 10},
        {name: "7", chance: 10},
        {name: "8", chance: 10},
        {name: "9", chance: 10},
        {name: "10", chance: 10},
    ],
    defaultState: "1",
    type: "classic"
}

export const ShortcutSetting: RslSetttingDto = {
    name: "Shortcut", states: [
        {name: "1", chance: 1/2*100},
        {name: "2", chance: 1/4*100},
        {name: "3", chance: 1/8*100},
        {name: "4", chance: 1/16*100},
        {name: "5", chance: 1/32*100},
        {name: "6", chance: 1/64*100},
        {name: "7", chance: 1/128*100},
        {name: "8", chance: 1/256*100},
        {name: "9", chance: 1/512*100},
    ],
    type: "classic"

}

export const CmgKeysSetting: RslSetttingDto =  {
    name: "CMG Keys", states: [
    {name: "Vanilla", chance: 80},
    {name: "Regional", chance: 10},
    {name: "Anywhere", chance: 10},
    ],
    defaultState: "Vanilla",
    type: "classic" 
}
export const CamcSetting: RslSetttingDto = {
    name: "CAMC", states: [
        {name: "Off", chance: 40},
        {name: "Texture", chance: 30},
        {name: "All", chance: 30},
      
    ],
    defaultState: "All",
    type: "classic"
}

export const  ShopSanityPriceSetting: RslSetttingDto = {
    name: "Shopsanity Price", states: [
        {name: "Random", chance: 20},
        {name: "Starting", chance: 20},
        {name: "Adult", chance: 20},
        {name: "Giant", chance: 20},
        {name: "Affordable", chance: 20},
      
    ],
    type: "classic"
}
export const BlueFireArrowSetting: RslSetttingDto =     {
    name: "Blue Fire Arrow", states: [
        {name: "Yes", chance: 30},
        {name: "No", chance: 70},
      
    ],
    defaultState: "No",
    type: "classic"
}

export const DamageSetting: RslSetttingDto =     {
        name: "Damage", states: [
            {name: "1/2", chance: 15},
            {name: "1", chance: 50},
            {name: "x2", chance: 20},
            {name: "x4", chance: 10},
            {name: "OHKO", chance: 5},
          
        ],
        defaultState: "1",
        type: "classic"
}

export const ItemPoolSetting: RslSetttingDto =  {
    name: "Item Pool", states: [
        {name: "Plentiful", chance: 10},
        {name: "Balanced", chance: 47.5},
        {name: "Scarce", chance: 27.5},
        {name: "Minimal", chance: 15},
      
    ],
    defaultState: "Balanced",
    type: "classic"
}
export const IceTrapSetting: RslSetttingDto =  {
    name: "Ice Trap", states: [
        {name: "Off", chance: 55},
        {name: "Normal", chance: 25},
        {name: "On", chance: 15},
        {name: "Mayhem", chance: 5},
      
    ],
    defaultState: "Off",
    type: "classic"
}

export const IceTrapApperanceSetting: RslSetttingDto ={
    name: "Ice Appearance", states: [
        {name: "Major", chance: 33},
        {name: "Junk", chance: 33},
        {name: "Any", chance: 33},
    ],
    defaultState: "Junk",
    type: "classic"
}
export const StartConsumableSetting: RslSetttingDto = {
    name: "Start Consumable", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "Yes",
    type: "classic"
}

export const MaxRupeeSetting: RslSetttingDto =  {
    name: "Start Rupees", 
    states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const RutoF1Setting: RslSetttingDto = {
    name: "Ruto F1", states: [
        {name: "Yes", chance: 50},
        {name: "No", chance: 50},
    ],
    defaultState: "No",
    type: "classic"
}

export const StartingHeartSettings: RslSetttingDto =  {
    name: "Starting Hearts", states: [
        {name: "3", chance: 1/2*100},
        {name: "4", chance: 1/4*100},
        {name: "5", chance: 1/6*100},
        {name: "6", chance: 1/8*100},
        {name: "7", chance: 1/16*100},
        {name: "8", chance: 1/32*100},
        {name: "9", chance: 1/64*100},
        {name: "10", chance: 1/128*100},
        {name: "11", chance: 1/256*100},
        {name: "12", chance: 1/512*100},
        {name: "13", chance: 1/1024*100},
        {name: "14", chance: 1/2048*100},
        {name: "15", chance: 1/4096*100},
        {name: "16", chance: 1/8192*100},
        {name: "17", chance: 1/16384*100},
        {name: "18", chance: 1/32768*100},
        {name: "19", chance: 1/65536*100},
        {name: "20", chance: 1/131072*100},
    ],
    type: "classic"
}


export const RslS6Settings : Array<RslSetttingDto> = [
    BridgeSetting,
    
 ]

 export const RslS7Settings : Array<RslSetttingDto> = [
    BridgeSetting,
    GbkSetting,
    TriforceHuntSetting,
    TrialSetting,
    CmgKeysSetting,
    BeatableOnlySettings,
    SilverRuppeSetting,
    KeysanitySetting,
    KeyringBkSetting,
    BombchusDropSetting,
    AdultTradeSetting,
    DekuSetting,
    KakGateSetting,
    FortressSetting,
    InteriorShuffleSetting,
    GrottoShuffleSetting,
    DungeonShuffleSetting,
    OverworldShuffleSetting,
    MixPoolSetting,
    BossShuffleSetting,
    OwlDropSetting,
    WarpSongSetting,
    ShopsanitySetting,
    TokensanitySetting,
    ScrubsanitySetting,
    CowsanitySetting,
    KsSetting,
    OcarinaSetting,
    OcarinaNoteSetting,
    GerudoCardSetting,
    FrogSongShuffleSetting,
    MapCompassShuffleSetting,
    BkSanitySetting,
    EscapeSequence,
    FreeEponaSetting,
    FreeScarecrowSetting,
    PrePlantedBean,
    BigPoesSetting,
    BlueFireArrowSetting,
    DamageSetting,
    ItemPoolSetting,
    IceTrapSetting,
    IceTrapApperanceSetting,
    StartConsumableSetting,
    MaxRupeeSetting,
    RutoF1Setting,
    BoulderSetting,
 ]
 
 